module.exports = __webpack_public_path__ + "img/202407_04.233caf59.jpg";